import { Skeleton, Stack, Wrap, WrapItem } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { HeadingXl } from '../text';
import { TightTag } from '../tags/TightTag';

interface Props {
	children: ReactNode;
	title: string | undefined;
	mt?: number;
	mb?: number;
	color?: string;
	maxW?: string;
	hasTag?: boolean;
	tagText?: string;
	tagColorScheme?: string;
}

export const HeaderStack: FC<Props> = ({
	title,
	children,
	mt = 0,
	mb = 6,
	maxW = 'lg',
	hasTag = false,
	tagText,
	tagColorScheme = 'info',
}) => (
	<Stack direction="row" justify="space-between" mt={mt} mb={mb}>
		{!!title ? (
			<Wrap align="center">
				<WrapItem>
					<HeadingXl
						as="h1"
						maxW={maxW}
						noOfLines={1}
						text={title}
						lineHeight="1.5"
					/>
				</WrapItem>
				{hasTag && (
					<WrapItem>
						<TightTag colorScheme={tagColorScheme}>
							{tagText}
						</TightTag>
					</WrapItem>
				)}
			</Wrap>
		) : (
			<Stack direction="column" w={36}>
				<Skeleton h="7" />
			</Stack>
		)}
		{children}
	</Stack>
);
